import { Injectable } from '@angular/core';
import { BodyClassService } from '@df/ui/body-class.service';
import { UseService } from '@df/util/service/use.service';
import { BehaviorSubject } from 'rxjs';
const FOOTER_VISIBILITY = 'footer-visibility';
const FOOTER_CLASS_HIDDEN = 'hidden-footer';
@Injectable({
    providedIn: 'root'
})
export class PageFooterVisibilityService {
    constructor(private useService: UseService, private bodyClassService: BodyClassService) {
        this.observe.subscribe(hidden => {
            hidden ? this.bodyClassService.add(FOOTER_CLASS_HIDDEN, this) : this.bodyClassService.remove(FOOTER_CLASS_HIDDEN, this);
        });
    }
    hide(source: any) {
        this.useService.lock(FOOTER_VISIBILITY, source);
    }
    show(source: any) {
        this.useService.unlock(FOOTER_VISIBILITY, source);
    }
    get observe(): BehaviorSubject<boolean> {
        return this.useService.getState(FOOTER_VISIBILITY).obs;
    }
}
